import { api } from '@/lib/api';

export interface SummaryByService {
  serviceId: string;
  name: string;
  color: string;
  shiftsCount: number;
  itemsCount: number;
  total: number;
  percentage: number;
}

export interface SummaryByExam {
  examTypeId: string;
  serviceId: string;
  name: string;
  shortName: string;
  unitValue: number;
  qty: number;
  subtotal: number;
}

export interface SummaryMonthlyPoint {
  month: string;
  total: number;
}

export interface MonthlySummary {
  month: string;
  cnpjId: string | null;
  total: number;
  shiftsCount: number;
  itemsCount: number;
  byService: SummaryByService[];
  byExam: SummaryByExam[];
  monthlySeries: SummaryMonthlyPoint[];
}

export const summaryApi = {
  get: (month: string, cnpjId: string | null) =>
    api.get<MonthlySummary>('/summary', {
      month,
      cnpjId: cnpjId ?? undefined,
    }),
};
